import { render, staticRenderFns } from "./FilteredCheckboxList.vue?vue&type=template&id=04b36500"
import script from "./FilteredCheckboxList.vue?vue&type=script&lang=js"
export * from "./FilteredCheckboxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports